import { useCallback, useState } from 'react';
import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import useQueryParameters from 'hooks/useQueryParameters';
import useApplicationBasedOverrides from 'hooks/useApplicationBasedOverrides';

export interface BraintreeTokensResult {
  token: string;
}

export class BraintreeTokensError extends Error {}

type BraintreeTokensHook = () => [
  () => Promise<BraintreeTokensResult>,
  Status,
  boolean,
];
const PATH = '/api/braintree_tokens';

const useBraintreeTokens: BraintreeTokensHook = () => {
  const [error, setError] = useState<boolean>(false);
  const [status, fetch] = useFetchApi();
  const { mockBraintreeTokens } = useQueryParameters();
  const overrideAttributes = useApplicationBasedOverrides();

  const braintreeTokens = useCallback(async () => {
    setError(false);
    const response = await fetch(PATH, {
      method: 'POST',
      body: {
        ...overrideAttributes,
        mockResponse: mockBraintreeTokens,
      },
    });

    if (!response.ok) {
      setError(true);
      return Promise.reject(new BraintreeTokensError());
    }

    const result: BraintreeTokensResult = await response.json();

    return Promise.resolve(result);
  }, [fetch, mockBraintreeTokens, overrideAttributes]);

  return [braintreeTokens, status, error];
};

export default useBraintreeTokens;
